<template>
<el-menu mode="vertical"
        class="side"
               :default-active="defaultActive">
        <template v-for="(menu) in sideMenu">
          <el-menu-item :index="menu.index"
                        :key="menu.name"
                        @click="handleMenuClick(menu)">
            <span class="top-tab-content">{{menu.label}}</span>
          </el-menu-item>
        </template>
      </el-menu>
</template>

<script>
import _ from 'lodash';
export default {
    data: function() {
        return {
        }
    },
    computed: {
        defaultActive: function() {
            const found = _.find(this.sideMenu, (it) => this.$route.name.includes(it.name))
            return found ? found.index : (this.sideMenu[0] && this.sideMenu[0].index) || '1-1'
        },
        sideMenu: function() {
            let resMenu = [
              {index:'1-1', name: 'media', label: '媒体管理', action: {type: 'route', val: 'media'}},
              {index:'1-2', name: 'adzone', label: '广告位管理', action: {type: 'route', val: 'adzone'}},
              {index:'1-3', name: 'deviceTargetingConfig', label: '广告定投配置', action: {type: 'route', val: 'deviceTargetingConfig'}}
            ]
            let reportMenu = [
              {index:'2-1', name: 'reportAccount', label: '账户报表', action: {type: 'route', val: 'reportAccount'}},
              {index:'2-2', name: 'reportMedia', label: '媒体报表', action: {type: 'route', val: 'reportMedia'}},
              {index:'2-3', name: 'reportAdzone', label: '广告位报表', action: {type: 'route', val: 'reportAdzone'}},
            ]
            let installedListCallbackMenu = [
              {index:'3-1', name: 'installedListCallback', label: '已安装列表回传管理(API)', action: {type: 'route', val: 'installedListCallback'}},
            ]
            
            if (_.find(resMenu, (it) => this.$route.name.includes(it.name))) {
                return resMenu
            } else if (_.find(installedListCallbackMenu, (it) => this.$route.name.includes(it.name))) {
                return installedListCallbackMenu
            } else {
                return reportMenu
            }
        }
    },
    methods: {
        handleMenuClick: function (menu) {
            this.$router.push({ name: menu.action.val}).catch(() => {});
        }
    }
}
</script>
<style scoped>
.side {
    height: 100%
}

</style>